import { createContext, useContext, useState, useCallback } from "react";
import translations from "../translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("rmd-lang") || "lv");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("rmd-lang", l);
  }, []);

  const t = useCallback((key) => {
    const keys = key.split(".");
    let value = translations[lang];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  }, [lang]);

  const tObj = useCallback((obj) => {
    if (!obj) return "";
    return obj[lang] || obj.lv || "";
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, tObj }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
